import React from "react";
import {HorizontalLoader, Loader, modal, utils} from "@mc/mc-legacy";
import { Card } from "reactstrap";
import { withRouter } from "react-router";
import * as RegistrationActions from "../actions/RegistrationActions";
import * as TypAutentizace from "mc/lib/api/gen/ucty/v1/TypAutentizace";
import RegistraceApi from "../api/gen/core/RegistraceApi";
import { connect } from "react-redux";
import ProcessLoginForm from "../components/form/ProcessLoginForm";
import CardTitle from "../components/layout/CardTitle";
import ProcessLoginError from "../components/registration/ProcessLoginError";
import { OVERENY } from "mc/lib/api/gen/ucty/v1/TypDuveryhodnosti";
import { withLang } from "../i18n/withLang";
import { i18n } from "../i18n/i18n";
import { EospPageContent } from "../components/layout/EospPageContent";
import {brandTitle} from "../i18n/Message";
import * as CustomModalActions from "../actions/CustomModalActions";
import Banner from "../components/banner/Banner";

class ProcessLoginPage extends React.Component<any> {
  // No tohle je pěkná prasárna!
  errors = [];
  state = {
    registerSuccess: null,
    errorMessage: undefined,
  };

  componentDidMount() {
    this.fetchData(this.props);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.fetchData(nextProps);
  }

  fetchData = (props) => {
    const params = new URLSearchParams(this.props.location.search);
    const key = params.get("key");
    props.dispatch(RegistrationActions.fetchRegistrationInfoIfNeeded(key));
  };
  handleSuccessRedirect = () => {
    const params = new URLSearchParams(this.props.location.search);
    const returnUrl = params.get("returnUrl");
    const key = params.get('key');

    let url = (window.appConfig as any).serverContextPath + "/registrace/success";
    url += "?uuid=" + key;
    if (returnUrl) {
        url += "&returnUrl=" + encodeURIComponent(returnUrl);
    }

    window.location.href = url;
  };
  handleSubmit = () => {
    const params = new URLSearchParams(this.props.location.search);
    const key = params.get("key");
      return RegistraceApi.newRegistration(key).then(
          this.props.dispatch(
              CustomModalActions.showInfo(
                  "",
                  <div style={{minWidth: 320}}>
                      <div className={"pb-2"}>{i18n(this.props.lang, "ProcessLoadingPage")}</div>
                      <HorizontalLoader/>
                  </div>,
                  null,
                  false,
                  false,
                  {
                      noHeader: true,
                  }
              )
          )
      ).then(() => {
          this.props.dispatch(modal.ModalActions.hide());
          this.handleSuccessRedirect()
      }).catch((error) => {
          this.props.dispatch(modal.ModalActions.hide());
          this.setState({
              registerSuccess: false,
              errorMessage: error.errors && error.errors._error,
          });
      });
  };
  getValues = () => {
    return [
      {
        key: "jmeno",
        name: i18n(this.props.lang, "ProcessLoginPage_jmeno"),
      },
      {
        key: "prijmeni",
        name: i18n(this.props.lang, "ProcessLoginPage_prijmeni"),
      },
      {
        key: "datumNarozeni",
        name: i18n(this.props.lang, "ProcessLoginPage_datumNarozeni"),
      },
      {
        key: "adresa",
        name: i18n(this.props.lang, "ProcessLoginPage_adresa"),
      },
      {
        key: "urovenDuveryhodnosti",
        name: i18n(this.props.lang, "ProcessLoginPage_urovenDuveryhodnosti"),
      },
    ];
  };
  someErrors = (userRegInfo) => {
    const values = this.getValues();

    for (let i = 0; i < values.length; i++) {
      if (!userRegInfo[values[i].key]) {
        this.errors[values[i].key] = i18n(this.props.lang, "ProcessLoginPage_nepredano");
      } else if (values[i].key === "urovenDuveryhodnosti" && userRegInfo[values[i].key] !== OVERENY) {
        this.errors[values[i].key] = i18n(this.props.lang, "ProcessLoginPage_malaUroven");
      }
    }

    return Object.keys(this.errors).length;
  };

  renderContent(userRegInfo) {
    const { registerSuccess, errorMessage } = this.state;

    if (userRegInfo.zpusobRegistrace === TypAutentizace.JMENO_HESLO) {
      return (
        <ProcessLoginError
          description={<p>{i18n(this.props.lang, "ProcessLoginPage_registraceJmenoHesloNotSupported")}</p>}
          zpusobRegistrace={userRegInfo.zpusobRegistrace}
        />
      );
    } else if (registerSuccess === false) {
      return (
        <ProcessLoginError
          description={<p>{errorMessage || i18n(this.props.lang, "ProcessLoginPage_loginError")}</p>}
          zpusobRegistrace={userRegInfo.zpusobRegistrace}
        />
      );
    } else if (this.someErrors(userRegInfo)) {
      return (
        <ProcessLoginError
          description={
            <p>
              {i18n(this.props.lang, "ProcessLoginPage_maloDat1")}
              <br />
              {i18n(this.props.lang, "ProcessLoginPage_maloDat2")}
            </p>
          }
          values={this.getValues()}
          errors={this.errors}
          zpusobRegistrace={userRegInfo.zpusobRegistrace}
        />
      );
    } else {
      return <ProcessLoginForm key={this.props.lang} userRegInfo={userRegInfo} onSubmit={this.handleSubmit} />;
    }
  }

  render() {
    const { userRegistrationInfoDetail, location } = this.props;
    const params = new URLSearchParams(location.search);
    const key = params.get("key");
    const userRegInfo: NovaRegistraceMetadataVO =
      userRegistrationInfoDetail.fetched && userRegistrationInfoDetail.id === key
        ? userRegistrationInfoDetail.data
        : null;

    if (!userRegInfo) {
      if (userRegistrationInfoDetail.isFetching) {
        return <Loader />;
      } else {
        return null;
      }
    }

    const title = brandTitle(this.props.lang);

        return (
       <>
           {typeof window !== "undefined" && window.appConfig?.isTST && (
               <Banner text="Testovací prostředí (TST)" />
           )}
          <EospPageContent className={"process-login-page"}>
            <CardTitle title={title}>
              <h4 className={"font-weight-bold mb-4 sub-title"}>
                {i18n(this.props.lang, "ProcessLoginPage_procesPrihlaseni")}:{" "}
                {i18n(this.props.lang, `TypAutentizace_${userRegInfo.zpusobRegistrace}`)}
              </h4>
            </CardTitle>
            {this.renderContent(userRegInfo)}
          </EospPageContent>
       </>
        );
  }
}

function mapStateToProps(state) {
  return {
    userRegistrationInfoDetail: utils.storeFromArea(state, RegistrationActions.USER_REGISTRATION_INFO_DETAIL_AREA),
  };
}

export default withRouter(withLang(connect(mapStateToProps)(ProcessLoginPage)));
